export default {"src":"/_next/static/media/refresh-icon.23709b5e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};